import { Button, Flashbar } from '@amzn/awsui-components-core';
import React from 'react';
import { useFlashMessage } from './AppBannerContext';

export const XptApplicationLevelBanner: React.FC = () => {
  const { messages, removeMessage } = useFlashMessage();

  const flashbarItems = messages.map(({ actionText, onAction, ...message }) => ({
    ...message,
    action: actionText ? <Button onClick={onAction}>{actionText}</Button> : undefined,
    onDismiss: () => removeMessage(message.id)
  }));

  return <Flashbar items={flashbarItems} stackItems={true} />;
};
